import { navigate } from 'gatsby';
import { useTranslation } from 'react-i18next';

import TopicsMenuItem from '@klv/molecules/topics-menu-item';

import * as s from './styles';

import type { ChangeEvent } from 'react';
import type { ITopicsMenu } from './types';

const generateDataUrl = (locale: string, sourceId: string) => sourceId.startsWith('/')
  ? `/hc/${locale}${sourceId}`
  : `/hc/${locale}/categories/${sourceId}`;

const TopicsMenu = ({
  selectedTopic = '', topics = [], ...props
}: ITopicsMenu) => {
  const { t } = useTranslation();

  if (!topics.length) {
    return null;
  }

  return (
    <>
      <s.DesktopTopicsMenu {...props}>
        {topics.map(({ name, sourceId }) => (
          <TopicsMenuItem
            key={name}
            selected={selectedTopic === name}
            sourceId={sourceId}
            topic={name}
            url={generateDataUrl(t('langCodes_localeLowerCase'), sourceId)}
          />
        ))}
      </s.DesktopTopicsMenu>
      <s.MobileTopicsMenu>
        <s.SelectArrow aria-hidden="true" fillColor="currentColor" iconName="ChevronDown" size={0.7} />
        <s.MobileTopicsMenuInput
          defaultValue={selectedTopic}
          name="Topic"
          onChange={(event: ChangeEvent<HTMLSelectElement>) => (event.target.selectedOptions[0].dataset.url && navigate(event.target.selectedOptions[0].dataset.url))}
          {...props}
        >
          <s.MobileTopicsMenuItem disabled hidden value="">Select a topic</s.MobileTopicsMenuItem>
          {topics.map(({ name, sourceId }) => (
            <s.MobileTopicsMenuItem
              data-url={generateDataUrl(t('langCodes_localeLowerCase'), sourceId)}
              key={name}
              value={name}
            >
              {name}
            </s.MobileTopicsMenuItem>
          ))}
        </s.MobileTopicsMenuInput>
      </s.MobileTopicsMenu>
    </>
  );
};

export default TopicsMenu;
